<div class="p-4 md:p-8 w-full flex flex-col items-center">
  <!-- Header -->
  <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 24px;">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">person</mat-icon>
    <h1 style="font-size: 1.4rem; font-weight: 800; color: #1e5a3f; margin: 0;">Mi perfil</h1>
  </div>

  <!-- Profile Card -->
  <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; width: 100%; max-width: 600px; overflow: hidden;">
    <!-- Card Header -->
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0; text-align: center;">
      <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f;">Información Personal</span>
    </div>

    <!-- User Data Grid -->
    <div style="padding: 20px 24px;">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Nombre</span>
          <p style="font-size: 0.9rem; font-weight: 600; color: #374151; margin: 2px 0 0;">{{userData?.nombre}} {{userData?.apellidos}}</p>
        </div>

        <div class="sm:text-right">
          <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Documento de identidad</span>
          <p style="font-size: 0.9rem; font-weight: 600; color: #374151; margin: 2px 0 0;">{{userData?.tipoId}} {{userData?.numeroId}}</p>
        </div>

        <div>
          <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Sexo</span>
          <p style="font-size: 0.9rem; font-weight: 600; color: #374151; margin: 2px 0 0;">{{userData?.sexo === 'M' ? 'Masculino' : 'Femenino'}}</p>
        </div>

        <div class="sm:text-right">
          <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Nacionalidad</span>
          <p style="font-size: 0.9rem; font-weight: 600; color: #374151; margin: 2px 0 0;">{{userData?.nacionalidad}}</p>
        </div>

        <div>
          <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Profesión</span>
          <p style="font-size: 0.9rem; font-weight: 600; color: #374151; margin: 2px 0 0;">{{userData?.profesion}}</p>
        </div>

        <div class="sm:text-right">
          <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Dirección</span>
          <p style="font-size: 0.9rem; font-weight: 600; color: #374151; margin: 2px 0 0;">{{userData?.ciudadResidencia}}, {{userData?.direccion}}</p>
        </div>

        <div>
          <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Teléfono</span>
          <p style="font-size: 0.9rem; font-weight: 600; color: #374151; margin: 2px 0 0;">{{userData?.prefijoTelefono}} {{userData?.telefono}}</p>
        </div>

        <div class="sm:text-right">
          <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Facturas</span>
          <p style="font-size: 0.9rem; font-weight: 600; color: #374151; margin: 2px 0 0;">{{userData?.recibeFactura===1?"Facturas Activadas":"Facturas Desactivadas"}}</p>
        </div>
      </div>
    </div>

    <!-- MFA Section -->
    <div style="border-top: 1px solid #e5e7eb; padding: 16px 24px;">
      <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;">
        <div style="display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">security</mat-icon>
          <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f;">Autenticación multifactor</span>
        </div>
        <mat-slide-toggle [(ngModel)]="MFAauthStatus" (change)="toggleMfa()" [disabled]="MFAauthStatus && !canDisableMfa">
          {{ MFAauthStatus ? 'Activado' : 'Desactivado' }}
        </mat-slide-toggle>
      </div>
    </div>

    <!-- Edit Button -->
    <div style="border-top: 1px solid #e5e7eb; padding: 16px 24px; display: flex; justify-content: center;">
      <button type="button" (click)="openDialog()"
        style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">edit</mat-icon>
        Editar datos
      </button>
    </div>
  </div>
</div>
